import React, { useRef, useState } from 'react';
import { Alert, Button, Card, Form, Input, Result, Tooltip, message } from 'antd';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import logo from '@/assets/logo.png';
import { requestPasswordReset, confirmPasswordReset } from '@/apis/account';
import { fetchLogout } from '@/apis/user';
import { getPostErrorMessage } from '@/apis/posts';
import StandaloneBack from '@/components/standaloneback';
import './index.scss';

const PasswordReset = ({ confirm = false }) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const busyRef = useRef(false);
  const uid = params.get('uid');
  const token = params.get('token');
  const invalidLink = confirm && (!uid || !token);
  const onFinish = async values => {
    if (busyRef.current || invalidLink) return;
    busyRef.current = true;
    setBusy(true);
    try {
      if (confirm) {
        await confirmPasswordReset({ ...values, uid, token });
        const result = await dispatch(fetchLogout());
        message.success('密码重置成功，请重新登录');
        if (!result.success) message.warning('本地已退出，服务器会话清理失败，请稍后重试退出');
        navigate('/login', { replace: true });
      } else {
        await requestPasswordReset(values.email.trim());
        setSent(true);
      }
    } catch (error) {
      message.error(getPostErrorMessage(error, confirm ? '密码重置失败' : '邮件发送失败，请稍后重试'));
    } finally { busyRef.current = false; setBusy(false); }
  };
  return <div className="passwordReset standalonePage">
    <StandaloneBack fallback="/login" disabled={busy} />
    <div className="demo-logo">
      <Link to="/">
        <Tooltip title="点击返回首页"><img src={logo} alt="IPartner" height={64} /></Tooltip>
      </Link>
    </div>
    <Card className="passwordReset-card" title={confirm ? '设置新密码' : '找回密码'} variant="borderless">
      {invalidLink ? <Alert type="error" showIcon message="重置链接缺少必要信息，请重新申请邮件" action={<Link to="/forgot-password">重新申请</Link>} />
        : sent ? <Result status="success" title="请查收邮件" subTitle="如果该邮箱已注册，你将收到重置密码的邮件。请同时检查垃圾邮件。" />
          : <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            {!confirm ? <Form.Item name="email" label="注册邮箱" rules={[{ required: true, message: '请输入注册邮箱' }, { type: 'email', message: '请输入有效邮箱' }]}><Input autoComplete="email" placeholder="你的注册邮箱" /></Form.Item>
              : <>
                <Form.Item name="new_password" label="新密码" rules={[{ required: true, message: '请输入新密码' }, { min: 8, message: '请至少输入 8 位密码' }]}><Input.Password autoComplete="new-password" /></Form.Item>
                <Form.Item name="confirm_password" label="确认新密码" dependencies={['new_password']} rules={[{ required: true, message: '请确认新密码' }, ({ getFieldValue }) => ({ validator: (_, value) => value === getFieldValue('new_password') ? Promise.resolve() : Promise.reject(new Error('两次密码不一致')) })]}><Input.Password autoComplete="new-password" /></Form.Item>
              </>}
            <Button type="primary" htmlType="submit" block loading={busy}>{confirm ? '重置密码' : '发送重置邮件'}</Button>
          </Form>}
    </Card>
  </div>;
};
export default PasswordReset;
